import {
	CostRecoveryTaskCode,
	FeeTaskCode,
	leapNullItemCostRecoveryTaskCode,
} from '@models/leap';

export const getLeapCodeLabelDescription = (
	code: FeeTaskCode | CostRecoveryTaskCode,
) => {
	if (!code) {
		return '';
	}

	return code.nameFileAs === leapNullItemCostRecoveryTaskCode.nameFileAs
		? leapNullItemCostRecoveryTaskCode.nameFileAs
		: `${code.nameFileAs} - ${code.billingDescription}`;
};
